module.exports = __webpack_public_path__ + "assets/3a5e6a30fe4e4ddb81865daa37885e31.mp3";